import ambulanceImage from './images/ambulance.svg';

const data = {
  image: {
    alt: 'ambulance with lights flashing',
    src: ambulanceImage.src,
  },
  summary: [
    'TAS/QLD State schemes cover ambulance services for residents of those States.',
    '1 day waiting period applies.',
  ],
  title: 'Plus unlimited emergency ambulance',
};

export default data;
